import Announcements from "@/components/announcements";
import CustomCursor from "@/components/customCursor";
import Footer from "@/components/footer";
import HeroSection, { AboutSection } from "@/components/heroSection";
import HeroSpacer from "@/components/herospacer";
import IntroScreen from "@/components/IntroScreen";
import FeaturedProject from "@/components/projectSection";
import ScrollProgress from "@/components/scrollProgress";
import V13Styles from "@/components/styles";
import { CurtainReveal } from "@/components/ui/curtainReveal";
import NavBar from "@/components/ui/navbar";
import SEO from "@/components/ui/seo";
import { useState } from "react";
import { X } from "lucide-react";

const HomePage = () => {
  const [showIntro, setShowIntro] = useState(
    () => !sessionStorage.getItem("v13-entered")
  );
  // const [popupStep, setPopupStep] = useState(1);
  // const handleClose = () => {
  //   if (popupStep === 1) {
  //     setPopupStep(null);
  //   }
  // };

  return (
    <div className="v13-root min-h-screen">
      {/* {popupStep && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999]">
          <div className="relative bg-white rounded-2xl w-[80vw] max-w-[80vw]">


            <button
              onClick={handleClose}
              className="absolute top-2 right-2 text-black p-1"
            >
                <X size={20} />

            </button>


            {popupStep === 1 && (
              <img
                src="/assets/home_popup/popup.jpeg"
                className="rounded-2xl w-full"
              />
            )}
          </div>
        </div>
      )} */}
      <V13Styles />
      <SEO />
      <CurtainReveal />
      <CustomCursor />
      <ScrollProgress />
      <NavBar isHomePage={true} />
      <HeroSection />
      <div className="relative z-10 bg-white">
        <AboutSection />
        {/* Business Verticals hidden per client request — re-enable later if needed */}
        {/* <BusinessSegments /> */}
        <FeaturedProject />
        {/* Subtle announcement marquee — DLF-style, placed above footer */}
        <Announcements />
        <Footer />
      </div>
    </div>
  );
};
export default HomePage